(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const summary = menu.querySelector('summary');
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        summary?.focus();
      }
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => { menu.open = false; });
    });
    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });

  const productForm = document.getElementById('ProductForm');
  const variantSelect = document.querySelector('[data-variant-select]');
  const reviewMode = document.body.dataset.reviewMode === 'true';
  if (variantSelect && productForm) {
    variantSelect.addEventListener('change', () => {
      const selected = variantSelect.selectedOptions[0];
      if (!selected) return;
      const price = document.getElementById('ProductPrice');
      const comparePrice = document.getElementById('ProductComparePrice');
      const offer = document.getElementById('ProductOffer');
      const addButton = productForm.querySelector('[data-add-to-cart]');
      const image = document.getElementById('ProductMainImage');
      const status = productForm.querySelector('[data-product-status]');
      const available = selected.dataset.available === 'true';
      if (price) price.textContent = selected.dataset.price || '';
      if (comparePrice) {
        const compareText = selected.dataset.comparePrice || '';
        comparePrice.textContent = compareText;
        comparePrice.setAttribute('aria-label', `Regular price: ${compareText}`);
        comparePrice.hidden = selected.dataset.onSale !== 'true' || !compareText;
      }
      if (offer) offer.hidden = selected.dataset.onSale !== 'true' || selected.dataset.halfPrice !== 'true';
      if (addButton && !reviewMode) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'BUY NOW' : 'Sold out';
      }
      if (image && selected.dataset.image) {
        image.src = selected.dataset.image;
        image.removeAttribute('srcset');
      }
      if (status && !reviewMode) status.textContent = available ? '' : 'This option is currently sold out.';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url.toString());
    });
    productForm.addEventListener('submit', (event) => {
      if (reviewMode || productForm.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      // Shopify or another platform listener may cancel later in propagation.
      queueMicrotask(() => {
        if (event.defaultPrevented || !productForm.checkValidity()) return;
        productForm.dataset.submitting = 'true';
        productForm.setAttribute('aria-busy', 'true');
      });
    });
    window.addEventListener('pageshow', () => {
      delete productForm.dataset.submitting;
      productForm.removeAttribute('aria-busy');
    });
  }

  const contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', (event) => {
      if (contactForm.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      // Let Shopify's validation or challenge handler cancel the event first.
      // Never retry or manufacture a success state on behalf of the platform.
      queueMicrotask(() => {
        if (event.defaultPrevented || !contactForm.checkValidity()) return;
        contactForm.dataset.submitting = 'true';
        contactForm.setAttribute('aria-busy', 'true');
      });
    });
    window.addEventListener('pageshow', () => {
      delete contactForm.dataset.submitting;
      contactForm.removeAttribute('aria-busy');
    });
  }

  const cartForm = document.getElementById('CartForm');
  if (cartForm && reviewMode) {
    cartForm.addEventListener('submit', (event) => {
      if (event.submitter?.name === 'checkout') event.preventDefault();
    });
  }
})();

/* rc.7: progressively enhanced supplied-image viewing and editorial reveal. */
(() => {
  'use strict';
  const dialog = document.getElementById('BrandLightbox');
  const gallery = [...document.querySelectorAll('[data-gallery-image]')];
  if (dialog && typeof dialog.showModal === 'function' && gallery.length) {
    const fullImage = dialog.querySelector('[data-gallery-full]');
    const count = dialog.querySelector('[data-gallery-count]');
    const original = dialog.querySelector('[data-gallery-original]');
    const close = dialog.querySelector('[data-gallery-close]');
    let index = 0;
    let opener = null;
    const display = (next) => {
      index = (next + gallery.length) % gallery.length;
      fullImage.src = gallery[index].href;
      fullImage.alt = gallery[index].querySelector('img')?.alt || 'HSOTONG supplied image';
      original.href = gallery[index].href;
      count.textContent = `${index + 1} / ${gallery.length}`;
    };
    gallery.forEach((link, position) => {
      link.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        display(position);
        try { dialog.showModal(); } catch { return; }
        event.preventDefault();
        opener = link;
        document.body.classList.add('has-gallery-modal');
        close.focus();
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-gallery-previous]').addEventListener('click', () => display(index - 1));
    dialog.querySelector('[data-gallery-next]').addEventListener('click', () => display(index + 1));
    dialog.addEventListener('keydown', (event) => {
      if (!dialog.open) return;
      if (event.key === 'Tab') {
        const last = dialog.querySelector('[data-gallery-next]');
        if (event.shiftKey && document.activeElement === close) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          close.focus();
        }
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        display(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('has-gallery-modal');
      opener?.focus();
    });
  }

  const sections = [...document.querySelectorAll('[data-reveal]')];
  if (!sections.length || typeof window.IntersectionObserver !== 'function' || typeof window.matchMedia !== 'function') return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting}) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (motion.matches || typeof target.animate !== 'function') return;
      const animation = target.animate(
        [{opacity: 0.72, transform: 'translateY(12px)'}, {opacity: 1, transform: 'translateY(0)'}],
        {duration: 420, easing: 'cubic-bezier(.2,.6,.3,1)'}
      );
      active.add(animation);
      animation.onfinish = () => active.delete(animation);
      animation.oncancel = () => active.delete(animation);
    });
  }, {threshold: 0.08});
  sections.forEach((section) => observer.observe(section));
  motion.addEventListener?.('change', () => {
    if (motion.matches) [...active].forEach((animation) => animation.cancel());
  });
})();
